import { Controller } from "@hotwired/stimulus"
import { Fancybox } from "@fancyapps/ui"

export default class extends Controller {
  connect() {
    this.initFancybox();
  }

  initFancybox() {
    Fancybox.bind(`[data-fancybox="gallery-${this.element.dataset.postId}"]`, {
      groupAll: true, // Group all items
      on: {
        ready: (fancybox) => {
          console.log(`Fancybox initialized for post ${this.element.dataset.postId}`);
        }
      }
    });

  }
}

